import * as React from 'react';
import { Component } from '../../lib/component';
import barsWhite from '../../static/bars-white.svg';
import barsBrand from '../../static/bars-brand.svg';
import { classes, style } from 'typestyle';
import { centerCenter } from 'csstips';

export interface LoadingProps {
  className?: string;
  light?: boolean;
  size?: number;
  text?: string;
}

export class Loading extends Component<LoadingProps> {
  render() {
    const { size = 48, className, light, text } = this.props;
    const style = { width: size };

    return (
      <div className={classes(Loading.styles.container, className)}>
        <img src={light ? barsWhite : barsBrand} style={style} />
        {text ? <p>{text}</p> : ''}
      </div>
    );
  }

  static styles = {
    container: style({
      ...centerCenter,
      position: 'relative',
      flexDirection: 'column',
    }),
  };
}
